<dgx-data-table
  [menuSettings]="menuSettings"
  [columns]="columns"
  [items]="paginatedTags"
  [totalNumResults]="filteredTags?.length || 0"
  [numResultsPerPage]="paginationPerPage"
  [hasNoResults]="hasNoResults"
  [isLoading]="isLoading"
  [isSorting]="false"
  [showPerPage]="true"
  [pageNum]="paginationPage"
  [isRowClickableFn]="isClickable"
  [isDescending]="isDescending"
  [orderBy]="sortBy"
  (perPageChange)="perPageChangeHandler($event)"
  (pageChange)="pageChangeHandler($event)"
  (updateSort)="updateSortHandler($event)"
  data-dgprop-item-clicked="Skill Row"
></dgx-data-table>

<ng-template #isFocusSkillColumnTemplate let-item>
  <button
    *ngIf="isOwner"
    class="hover-color-blue"
    [ngClass]="{
      'color-warning': item.requestingUserIsFocused,
      'color-ebony-a18': !item.requestingUserIsFocused
    }"
    (click)="toggleFocused($event, item)"
    [ngbTooltip]="getFocusSkillTootip(item.requestingUserIsFocused)"
    [attr.aria-label]="getFocusSkillI18n(item)"
    data-dgat="profile-skills-list-b3b"
  >
    <df-icon size="small" icon="star" #focusElement></df-icon>
  </button>

  <df-icon
    *ngIf="!isOwner && item.isFocusSkillForOwner"
    icon="star"
    size="small"
    class="color-warning"
    [ngbTooltip]="i18n.Core_FocusSkill"
    [attr.aria-label]="i18n.Core_FocusSkill"
  ></df-icon>
</ng-template>

<ng-template #skillNameColumnTemplate let-item>
  <span
    [textContent]="item.title"
    class="ib-v-middle break"
    data-dgprop-item-clicked="Skill Row Name"
    (click)="skillClickHandler($event, item)"
    (keydown)="handleSkillKeydown($event, item)"
    [attr.role]="!!authUser ? 'button' : null"
    [attr.tabindex]="!!authUser ? 0 : -1"
    [attr.aria-label]="getSkillAriaLabel(item.title)"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></span>
</ng-template>

<!-- Self rating template-->
<ng-template #selfRatingColumnTemplate let-item>
  <dgx-profile-skills-list-self-rating
    [tag]="item"
    [isOwner]="isOwner"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-self-rating>
</ng-template>

<!-- Manager rating template-->
<ng-template #managerRatingColumnTemplate let-item>
  <dgx-profile-skills-list-manager-rating
    [tag]="item"
    [canRequestManagerRating]="authUser?.canRequestManagerRating"
    [isOwner]="isOwner"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-manager-rating>
</ng-template>

<!-- Peer rating template-->
<ng-template #peerRatingColumnTemplate let-item>
  <dgx-profile-skills-list-peer-ratings
    [tag]="item"
    [canRequestPeerRating]="authUser?.canRequestPeerRating"
    [isOwner]="isOwner"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-peer-ratings>
</ng-template>

<!-- Skill review template-->
<ng-template #skillReviewColumnTemplate let-item>
  <dgx-profile-skills-list-skill-review
    [tag]="item"
    [isOwner]="isOwner"
    [canEvaluateSkills]="authUser?.canEvaluateSkills"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-skill-review>
</ng-template>

<!-- Skill certification template-->
<ng-template #skillCertificationColumnTemplate let-item>
  <dgx-profile-skills-list-skill-certification
    [tag]="item"
    [isOwner]="isOwner"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-skill-certification>
</ng-template>

<!-- Target rating template-->
<ng-template #skillTargetColumnTemplate let-item>
  <dgx-profile-skills-list-target-rating
    [tag]="item"
    [isOwner]="isOwner"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-target-rating>
</ng-template>

<!-- Other ratings template-->
<ng-template #otherRatingsColumnTemplate let-item>
  <dgx-profile-skills-list-other-ratings
    [tag]="item"
    [profile]="owner"
    [ngStyle]="{ cursor: !!authUser ? 'pointer' : 'text' }"
  ></dgx-profile-skills-list-other-ratings>
</ng-template>

<!-- Signal count template-->
<ng-template #signalCountColumnTemplate let-item>
  <dgx-signal-popover
    [tag]="item"
    [skillName]="item.title"
    [signalCount]="item.signalCount"
    [signalSummary]="item.signals"
    (click)="goToSignalPage($event, item)"
    (keydown)="handleSignalsKeydown($event, item)"
    [isButton]="true"
  ></dgx-signal-popover>
</ng-template>
